<script lang="ts">
  import {
    ArrowUp,
    Pencil,
    ArrowDown,
    Trash,
    RepostIcon,
    Plus,
    AddToQueue,
  } from 'core-components';
  import { createEventDispatcher } from 'svelte';

  export let blocks, section, index, currentFocusedBlock, pageType;
  const dispatch = createEventDispatcher();

  const handleEdit = event => {
    dispatch('edit');
  };
  const handleChangeDesign = event => {
    dispatch('changeDesign');
  };
  const handleMoveUp = event => {
    dispatch('moveUp');
  };
  const handleMoveDown = event => {
    dispatch('moveDown');
  };
  const handleTrash = event => {
    dispatch('trash');
  };
  const handleAddSection = position => {
    dispatch('addSection', { position });
  };
</script>

<div
  class="absolute bottom-0 left-0 right-0 top-0 z-50 flex flex-col items-center justify-center bg-black bg-opacity-50 md:opacity-0 md:hover:opacity-100"
  class:opacity-0={currentFocusedBlock.type === section.type || index === 0}
  class:opacity-100={section.type === 'HeaderContent'}
>
  <!-- Cannot add new section at the very top of the page -->
  {#if (index > 0 && pageType == 'marekting') || (index > 1 && pageType == 'default')}
    <button
      on:click={() => handleAddSection('before')}
      class="
      left-50%
      transform-translate-50% border-input
      absolute
      -top-[20px]
      hidden
      gap-2
      rounded-md border border-[#0094ff] bg-[#f5fbff] px-4 py-2 text-sm text-[#0094ff] md:flex"
    >
      <Plus />
      Add Section</button
    >
  {/if}

  <div
    class="hidden cursor-pointer flex-col items-center justify-center gap-4 md:flex"
    class:!flex={section.type === 'HeaderContent'}
  >
    <div class="flex gap-2 rounded-md bg-white p-2">
      {#if section.type === 'HeaderContent'}
        <button
          class="flex gap-2 rounded-md bg-[#0594fa] px-4 py-2 text-white"
          style="font-family:Inter Tight"
          on:click={handleEdit}
        >
          <Pencil /> Edit Website Header
        </button>
      {:else if section.type === 'Footer'}
        <button
          class="rounded-md bg-[#0594fa] px-4 py-2 text-white"
          style="font-family:Inter Tight"
          on:click={handleEdit}
        >
          Edit Website Footer
        </button>
      {:else if section.type === 'Services'}
        <button
          class="flex gap-2 rounded-md bg-[#0594fa] px-4 py-2 font-medium text-white"
          style="font-family:Inter Tight"
          on:click={handleEdit}
        >
          <AddToQueue />
          Add / Edit Services
        </button>
        <button
          disabled={currentFocusedBlock.index <= 2}
          class="border-input rounded-md border bg-white p-2 text-black disabled:opacity-30"
          style="font-family:Inter Tight"
          on:click={handleMoveUp}
        >
          <ArrowUp />
        </button>
        <button
          disabled={currentFocusedBlock.index >= blocks.length - 2}
          class="border-input rounded-md border bg-white p-2 text-black disabled:opacity-30"
          style="font-family:Inter Tight"
          on:click={handleMoveDown}
        >
          <ArrowDown />
        </button>
      {:else if section.type === 'Hero'}
        <button
          class="inline-flex items-center gap-2 rounded-md bg-[#0594fa] px-4 py-2 text-white"
          style="font-family:Inter Tight"
          on:click={handleEdit}
        >
          <Pencil /> Edit Hero
        </button>
        <button
          class="flex gap-2 rounded-md border border-[#0094ff] bg-[#f5fbff] p-2 text-sm font-medium"
          style="font-family:Inter Tight"
          on:click={handleChangeDesign}
        >
          <RepostIcon />
          Change Design
        </button>
      {:else}
        <button
          class="border-input rounded-md border bg-white p-2 text-black"
          style="font-family:Inter Tight"
          on:click={handleEdit}
        >
          <Pencil />
        </button>
        <button
          disabled={currentFocusedBlock.index <= 2}
          class="border-input rounded-md border bg-white p-2 text-black disabled:opacity-30"
          style="font-family:Inter Tight"
          on:click={handleMoveUp}
        >
          <ArrowUp />
        </button>
        <button
          disabled={currentFocusedBlock.index >= blocks.length - 2}
          class="border-input rounded-md border bg-white p-2 text-black disabled:opacity-30"
          style="font-family:Inter Tight"
          on:click={handleMoveDown}
        >
          <ArrowDown />
        </button>
        {#if section.type !== 'Services' && section.type !== 'Benefits' && section.type !== 'AboutUs' && section.type !== 'Faq' && section.type !== 'ContactForm' && section.type !== 'Testimonials' && !section.model?.isServiceBlock}
          <button
            class="border-input rounded-md border bg-white p-2 text-red-500"
            style="font-family:Inter Tight"
            on:click={handleTrash}
          >
            <Trash />
          </button>
        {/if}
      {/if}
    </div>
    {#if section.variationMax > 0 && section.type != 'Hero' && currentFocusedBlock?.type != 'Footer'}
      <div>
        <button
          class="flex gap-2 rounded-md border border-[#0094ff] bg-[#f5fbff] p-2 text-sm font-medium"
          style="font-family:Inter Tight"
          on:click={handleChangeDesign}
        >
          <RepostIcon />
          Change Design
        </button>
      </div>
    {/if}
  </div>

  <!-- Cannot add new section at the very bottom of the page -->
  {#if index != blocks.length - 1 && index > 0}
    <button
      on:click={() => handleAddSection('after')}
      class="
      left-50%
      transform-translate-50% border-input
      border-input
      absolute
      -bottom-[20px]
      hidden
      gap-2
      rounded-md border border-[#0094ff] bg-[#f5fbff] px-4 py-2 text-sm text-[#0094ff] md:flex"
    >
      <Plus />
      Add Section</button
    >
  {/if}
</div>

<!-- position: absolute; top: -25px; left: 50%; transform: translate(-50%); -->
